(() => {
  const initialize = (root) => root.querySelectorAll('.tp-product[data-section-id]').forEach((page) => {
    if (page.dataset.tpInitialized) return;
    page.dataset.tpInitialized = 'true';
    const thumbs = [...page.querySelectorAll('.tp-thumb')];
    const image = page.querySelector('.tp-main-image');
    let current = 0;
    const showImage = (index) => {
      if (!thumbs.length || !image) return;
      current = (index + thumbs.length) % thumbs.length;
      const target = thumbs[current];
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = target.dataset.large;
      image.alt = target.dataset.alt || '';
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === current);
        thumb.setAttribute('aria-current', String(i === current));
      });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));

    page.querySelectorAll('.tp-size-cards button').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.classList.contains('is-selected')));
      button.addEventListener('click', () => {
        page.querySelectorAll('.tp-size-cards button').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        page.querySelector('.tp-size-value').textContent = button.dataset.size;
      });
    });

    const offers = [...page.querySelectorAll('.tp-offer')];
    offers.forEach((button) => button.addEventListener('click', () => {
      page.querySelectorAll('.tp-offer').forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-checked', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-checked', 'true');
      page.querySelector('.tp-offer-label').textContent = button.dataset.label;
      page.querySelector('.tp-cart-quantity').value = button.dataset.quantity;
      page.querySelector('.tp-cart-total').textContent = button.dataset.total;
    }));
    page.querySelector('.tp-offers')?.addEventListener('keydown', (event) => {
      const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const active = offers.indexOf(document.activeElement);
      const next = event.key === 'Home' ? 0
        : event.key === 'End' ? offers.length - 1
        : (active + (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1) + offers.length) % offers.length;
      offers[next].focus();
      offers[next].click();
    });
    page.querySelector('.tp-variant')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const price = Number(option.dataset.price);
      const qty = Number(page.querySelector('.tp-cart-quantity').value);
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: page.dataset.currency || 'USD'
      });
      page.querySelectorAll('.tp-offer').forEach((button) => {
        button.dataset.total = formatter.format(price * Number(button.dataset.quantity) / 100);
        button.querySelector('span:last-child').textContent = button.dataset.total;
      });
      page.querySelector('.tp-cart-total').textContent = formatter.format(price * qty / 100);
      page.querySelector('.tp-current-price').textContent = formatter.format(price / 100);
      const compare = Number(option.dataset.compare || 0);
      const oldPrice = page.querySelector('.tp-old-price');
      const savings = page.querySelector('.tp-save-tag');
      oldPrice.hidden = compare <= price;
      savings.hidden = compare <= price;
      if (compare > price) {
        oldPrice.textContent = formatter.format(compare / 100);
        savings.textContent = `Save ${formatter.format((compare - price) / 100)}`;
      }
    });
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
